import React from 'react';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import fonts from '../../tokens/fonts';
import fontWeights from '../../tokens/fontWeights';
import colours from '../../tokens/colours';
import baseStyles from '../../atoms/styles/baseStyles';
import ellipsisStyles from '../../atoms/styles/ellipsisStyles';
import { ITEM_HEIGHT } from './constants';
import stackOrder from '../../tokens/stackOrder';
export const getStyles = createUseStyles({
    ...baseStyles,
    root: {
        ...ellipsisStyles,
        display: 'block',
        fontFamily: fonts.roboto,
        fontWeight: fontWeights.Regular,
        padding: [16, 16, 0, 16],
        height: ITEM_HEIGHT,
        fontSize: '1.4rem',
        lineHeight: '2rem',
        color: colours.primary,
        cursor: 'pointer',
        borderRadius: 4,
        backgroundColor: 'transparent',
        transition: ['background-color', '0.2s', 'linear'],
        position: 'relative',
        zIndex: stackOrder.dropdownMenu,
        '&:hover': {
            backgroundColor: colours.quarternary,
        },
    },
});
const MenuItem = ({ children, to, onClick = () => { }, setValue }) => {
    const styles = getStyles();
    const onLinkClick = () => {
        onClick();
        setValue(children);
    };
    return (React.createElement("li", null,
        React.createElement(Link, { className: styles.root, to: to, onClick: onLinkClick }, children)));
};
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map